import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectAddressContour } from '../../../store/address/address.selectors'
import { selectIsMapReady } from '../../../store/map/map.selectors'
import { withEverySelectorTruthy } from '../../utils/react-redux'
import { useMapContext } from '../MapContext'
import { reverseShape } from './map.polygon.utils'

const SOURCE_ID_AREA = 'city-shape-area-src'
const SOURCE_ID_LIMIT = 'city-shape-limit-src'
const LAYER_AREA_ID = 'city-shape-area'
const LAYER_LIMIT_ID = 'city-shape-limit'
const CONTOUR_COLOR = '#1A1A1A'

const getPolygonLayer = () => ({
  id: LAYER_AREA_ID,
  type: 'fill',
  source: SOURCE_ID_AREA,
  paint: {
    'fill-opacity': 0.18,
    'fill-color': CONTOUR_COLOR
  }
})

const getLineLayer = () => ({
  id: LAYER_LIMIT_ID,
  type: 'line',
  source: SOURCE_ID_LIMIT,
  paint: {
    'line-opacity': 0.7,
    'line-width': 2,
    'line-color': CONTOUR_COLOR,
    'line-dasharray': [1, 2]
  }
})

const createGeoJSON = geometry => ({
  type: 'geojson',
  data: {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: {},
        geometry
      }
    ]
  }
})

const MapAddressContour = ({ reverse = true }) => {
  const { map } = useMapContext()
  const contour = useSelector(selectAddressContour)
  const shape = useMemo(() => (contour && reverse ? reverseShape(contour) : contour), [reverse, contour])
  const isMapReady = useSelector(selectIsMapReady)

  const cleanShape = () => {
    try {
      if (!map.getLayer(LAYER_AREA_ID)) return
      map.removeLayer(LAYER_AREA_ID)
      map.removeLayer(LAYER_LIMIT_ID)
      map.removeSource(SOURCE_ID_AREA)
      map.removeSource(SOURCE_ID_LIMIT)
    } catch (error) {
      console.error('failed to cleanShape', error)
    }
  }

  const drawShape = () => {
    if (!shape) return

    try {
      map.addSource(SOURCE_ID_AREA, createGeoJSON(shape))
      map.addSource(SOURCE_ID_LIMIT, createGeoJSON(contour))
      map.addLayer(getPolygonLayer())
      map.addLayer(getLineLayer())
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    if (!isMapReady || !shape) return
    drawShape()
  }, [shape, isMapReady])

  useEffect(
    () => () => {
      cleanShape()
    },
    []
  )

  return <></>
}

export default withEverySelectorTruthy(selectAddressContour)(MapAddressContour)
